/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface BvUnstyledBtnSignature {
  Args: {
    onClick?: (e: Event) => void;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLButtonElement;
}

const BvUnstyledBtnComponent = templateOnlyComponent<BvUnstyledBtnSignature>();

export default BvUnstyledBtnComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvUnstyledBtn: typeof BvUnstyledBtnComponent;
    'bv-unstyled-btn': typeof BvUnstyledBtnComponent;
  }
}
